import { ThemeEvents } from '@theme/events';

class PdpTabs extends HTMLElement {
  connectedCallback() {
    this.tabButtons = Array.from(this.querySelectorAll('[data-pdp-tab-trigger]'));
    this.tabPanels = Array.from(this.querySelectorAll('[data-pdp-tab-panel]'));

    if (this.tabButtons.length === 0 || this.tabPanels.length === 0) {
      return;
    }

    this.tabButtons.forEach((button) => {
      button.addEventListener('click', this.handleTabClick);
      button.addEventListener('keydown', this.handleTabKeydown);
    });

    this.setActiveTab(this.tabButtons.find((button) => button.getAttribute('aria-selected') === 'true') || this.tabButtons[0]);
  }

  disconnectedCallback() {
    this.tabButtons.forEach((button) => {
      button.removeEventListener('click', this.handleTabClick);
      button.removeEventListener('keydown', this.handleTabKeydown);
    });
  }

  handleTabClick = (event) => {
    this.setActiveTab(event.currentTarget);
  };

  handleTabKeydown = (event) => {
    const currentIndex = this.tabButtons.indexOf(event.currentTarget);
    let nextIndex = currentIndex;

    if (event.key === 'ArrowRight') {
      nextIndex = (currentIndex + 1) % this.tabButtons.length;
    } else if (event.key === 'ArrowLeft') {
      nextIndex = (currentIndex - 1 + this.tabButtons.length) % this.tabButtons.length;
    } else if (event.key === 'Home') {
      nextIndex = 0;
    } else if (event.key === 'End') {
      nextIndex = this.tabButtons.length - 1;
    } else {
      return;
    }

    event.preventDefault();
    this.setActiveTab(this.tabButtons[nextIndex]);
    this.tabButtons[nextIndex].focus();
  };

  setActiveTab(activeButton) {
    const panelId = activeButton.getAttribute('aria-controls');

    this.tabButtons.forEach((button) => {
      const isActive = button === activeButton;
      button.setAttribute('aria-selected', isActive ? 'true' : 'false');
      button.tabIndex = isActive ? 0 : -1;
    });

    this.tabPanels.forEach((panel) => {
      const isActive = panel.id === panelId;
      panel.hidden = !isActive;
    });
  }
}

if (!customElements.get('pdp-tabs')) {
  customElements.define('pdp-tabs', PdpTabs);
}

document.addEventListener(ThemeEvents.variantUpdate, (event) => {
  const html = event.detail?.data?.html;

  if (!html) {
    return;
  }

  document.querySelectorAll('[data-pdp-variant-region]').forEach((target) => {
    const key = target.getAttribute('data-pdp-variant-region');

    if (!key) {
      return;
    }

    const source = html.querySelector(`[data-pdp-variant-region="${CSS.escape(key)}"]`);

    if (source) {
      target.replaceWith(source);
    }
  });
});
